import FactorSearchForm from "./FactorSearchForm";

export default FactorSearchForm;
